(() => {
  window.swinger.observer.initialize('form[role="search"] input[name="q"]', (elem) => {
    if (
      window.location.search.indexOf('?q=') === -1
      && window.location.search.indexOf('&q=') === -1
    ) {
      return;
    }

    const url = new URL(window.location);
    const params = url.searchParams;

    elem.value = params.get('q').replace(/><|<|>/g, ' ');
  }, false);
})();
